var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBubble = function SvgBubble(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 170,
    viewBox: "0 0 164 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.264 132.953C157.368 118.962 164 101.26 164 82.0093C164 36.7168 127.287 0 82 0C36.7127 0 0 36.7168 0 82.0093C0 127.302 36.7127 164.019 82 164.019C93.1679 164.019 103.814 161.786 113.518 157.742L146.758 170L146.264 132.953Z",
    fill: "#82C6FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9785,
    cy: 85,
    r: 17.0098,
    fill: "#E4F3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.9981,
    cy: 85,
    r: 17.0098,
    fill: "#E4F3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.018,
    cy: 85,
    r: 17.0098,
    fill: "#E4F3FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBubble);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTY0IiBoZWlnaHQ9IjE3MCIgdmlld0JveD0iMCAwIDE2NCAxNzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQ2LjI2NCAxMzIuOTUzQzE1Ny4zNjggMTE4Ljk2MiAxNjQgMTAxLjI2IDE2NCA4Mi4wMDkzQzE2NCAzNi43MTY4IDEyNy4yODcgMCA4MiAwQzM2LjcxMjcgMCAwIDM2LjcxNjggMCA4Mi4wMDkzQzAgMTI3LjMwMiAzNi43MTI3IDE2NC4wMTkgODIgMTY0LjAxOUM5My4xNjc5IDE2NC4wMTkgMTAzLjgxNCAxNjEuNzg2IDExMy41MTggMTU3Ljc0MkwxNDYuNzU4IDE3MEwxNDYuMjY0IDEzMi45NTNaIiBmaWxsPSIjODJDNkZGIi8+CjxjaXJjbGUgY3g9IjM2Ljk3ODUiIGN5PSI4NSIgcj0iMTcuMDA5OCIgZmlsbD0iI0U0RjNGRiIvPgo8Y2lyY2xlIGN4PSI4MS45OTgxIiBjeT0iODUiIHI9IjE3LjAwOTgiIGZpbGw9IiNFNEYzRkYiLz4KPGNpcmNsZSBjeD0iMTI3LjAxOCIgY3k9Ijg1IiByPSIxNy4wMDk4IiBmaWxsPSIjRTRGM0ZGIi8+Cjwvc3ZnPgo=";